import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { hideModal, MODAL_CARD_FORM_TRASHED } from '../../../../modules/modals';
import FormContent from './components/FormContent/FormContent';

export class CardFormTrashed extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_CARD_FORM_TRASHED});
  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleTrashedCard"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const { zIndex, initialValues } = this.props;
    const {formatMessage} = this.context;
    return (
      <Modal
        isOpen = {true}
        style = {{
            overlay : {zIndex: 999999},
        }}
        onRequestClose={this.handleClose}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
            {
              this.getTitle()
            }
            <div
                onClick={this.handleClose}
                className="create-dialog-modal-content__close"
            ></div>
        </div>
        <div className="create-dialog-modal-content__body">
          <FormContent initialValues={initialValues} handleClose={this.handleClose}  />
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(CardFormTrashed)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardTrashed/components/CardFormTrashed/CardFormTrashed.jsx